export const isProductDiscontinued = (product) => product.isDiscontinued;

export const isProductUnavailableForUS = () => false;

export const isProductUnavailable = (product) => {
  return isProductDiscontinued(product);
};

const getVariantId = (variant = {}) => variant.variantId || variant.id;

const hasAnyEffectiveAvailableVariant = ({
  variants = [],
  stockPriceVariants = [],
  shouldUseStockPriceOverride = false,
}) => {
  if (!variants.length) {
    return false;
  }

  const stockPriceByVariantId = new Map(
    (stockPriceVariants || []).map((variant) => [
      String(getVariantId(variant)),
      Boolean(variant?.isInStock),
    ])
  );

  return variants.some((productVariant) => {
    const productVariantId = String(getVariantId(productVariant));
    const isAvailableFromProduct = Boolean(productVariant?.isAvailable);

    if (
      shouldUseStockPriceOverride &&
      stockPriceByVariantId.has(productVariantId)
    ) {
      return stockPriceByVariantId.get(productVariantId);
    }

    return isAvailableFromProduct;
  });
};

export const normalizeProductDiscontinuedState = ({
  product = {},
  stockPriceVariants = [],
  shouldUseStockPriceOverride = false,
} = {}) => {
  const originalIsDiscontinued = Boolean(product?.isDiscontinued);

  if (!originalIsDiscontinued) {
    return {
      normalizedIsDiscontinued: false,
      isDiscontinuedOverride: false,
    };
  }

  const hasAnyAvailableVariant = hasAnyEffectiveAvailableVariant({
    variants: product?.variants,
    stockPriceVariants,
    shouldUseStockPriceOverride,
  });
  const normalizedIsDiscontinued = !hasAnyAvailableVariant;

  return {
    normalizedIsDiscontinued,
    isDiscontinuedOverride: !normalizedIsDiscontinued,
  };
};
